import {Form} from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import {useFormik} from 'formik'
import {mixed, object, string} from 'yup'
import SubjectsSearchControl from '../subjects/SearchControl'
import LevelsSearchControl from '../levels/SearchControl'
import LocationsFormControl from '../locations/FormControl'
import {apiErrorsToFormik} from '../../utils/api'

export default function TutorRequestForm({initialValues, onSubmit}) {
  const validationSchema = object({
    subject: mixed().required('Subject is required.'),
    level: mixed().required('Level is required.'),
    lessonType: string().required(),
    location: object().when('lessonType', {
      is: 'in_person',
      then: schema => schema.required('Please enter your location.')
    }).nullable(),
    message: string().required('Please enter a message.')
  })

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      try {
        onSubmit(values)
      } catch(e) {
        formik.setErrors(apiErrorsToFormik(e))
      } finally {
        formik.setSubmitting(false)
      }
    }
  })

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Row>
        <Col xs={12} md={6}>
          <Form.Group controlId="subject" className="mb-3">
            <Form.Label>Subject</Form.Label>
            <div className={!!formik.errors.subject ? 'is-invalid' : ''}>
              <SubjectsSearchControl
                onChange={value => formik.setFieldValue('subject', value)}
                subject={formik.values.subject}
              />
            </div>
            {formik.errors.subject &&
              <Form.Control.Feedback type="invalid">
                {formik.errors.subject}
              </Form.Control.Feedback>
            }
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group controlId="level">
            <Form.Label>Level</Form.Label>
            <div className={!!formik.errors.level ? 'is-invalid' : ''}>
              <LevelsSearchControl
                onChange={value => formik.setFieldValue('level', value)}
                level={formik.values.level}
                subject={formik.values.subject}
              />
            </div>
            {formik.errors.level &&
              <Form.Control.Feedback type="invalid">
                {formik.errors.level}
              </Form.Control.Feedback>
            }
          </Form.Group>
        </Col>
      </Row>

      <Form.Group controlId="lessonType" className="mb-3">
        <Form.Label>Lesson Type</Form.Label>
        <Form.Check
          type="radio"
          name="lessonType"
          value="online"
          label="Online"
          id="lessonType-online"
          onChange={formik.handleChange}
          defaultChecked={formik.values.lessonType === 'online'}
        />
        <Form.Check
          type="radio"
          name="lessonType"
          value="in_person"
          label="In Person"
          id="lessonType-in-person"
          onChange={formik.handleChange}
          defaultChecked={formik.values.lessonType === 'in_person'}
        />
        {formik.errors.lessonType &&
          <Form.Control.Feedback type="invalid">
            {formik.errors.lessonType}
          </Form.Control.Feedback>
        }
      </Form.Group>

      {formik.values.lessonType === 'in_person' &&
        <Form.Group controlId="location" className="mb-3">
          <Form.Label>Location</Form.Label>
          <div className={!!formik.errors.location ? 'is-invalid' : ''}>
            <LocationsFormControl
              location={formik.values.location}
              onChange={value => formik.setFieldValue('location', value)}
            />
          </div>
          {formik.errors.location &&
            <Form.Control.Feedback type="invalid">
              {formik.errors.location}
            </Form.Control.Feedback>
          }
        </Form.Group>
      }

      <Form.Group controlId="message" className="mb-3">
        <Form.Label>Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          {...formik.getFieldProps('message')}
          isInvalid={!!formik.errors.message}
        />
        {formik.touched.message && formik.errors.message &&
          <Form.Control.Feedback type="invalid">
            {formik.errors.message}
          </Form.Control.Feedback>
        }
      </Form.Group>

      <div className="text-end">
        <Button type="submit" disabled={formik.isSubmitting}>Send</Button>
      </div>
    </Form>
  )
}
